"use client";

import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { Column } from "@tanstack/react-table";

interface SortableHeaderProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: Column<any, any> | undefined;
  label: string;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  column,
  label,
}) => {
  const sorted = column?.getIsSorted();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ml-2 h-8 px-2 text-xs font-medium text-muted-foreground hover:text-foreground data-[sorted=true]:text-foreground"
      data-sorted={!!sorted}
      onClick={() => {
        column?.toggleSorting?.();
      }}
    >
      {label}
      {sorted === "asc" ? (
        <ArrowUp className="h-3.5 w-3.5" />
      ) : sorted === "desc" ? (
        <ArrowDown className="h-3.5 w-3.5" />
      ) : (
        <ArrowUpDown className="h-3.5 w-3.5 opacity-50" />
      )}
    </Button>
  );
};
